import adminRoutes from './urls/admin'
import coreRoutes from './urls/core'
import authRoutes from './urls/auth'

export const URLs = {
  ...adminRoutes,
  ...coreRoutes,
  ...authRoutes
}
